<template>
  <div class="settings-container" v-if="props.data">

      <div class="section-header">
        <h3>Creator management</h3>
      </div>

      <div class="setting-item" v-if="props.data.downloadCreatorPerformanceReport">
        <span>Download creator performance report</span>
        
        <Switch v-if="props.canEdit" :checked="props.data.downloadCreatorPerformanceReport.permission === 100"
        @click.native="switchItem(props.data, 'downloadCreatorPerformanceReport.permission')" />
        <span v-else>{{ switchText(props.data.downloadCreatorPerformanceReport.permission) }}</span>
        
    </div>

      <div class="section-header section-header-2"  v-if="props.data.downloadReports">
        <h3>Report dashboard</h3>
        <el-select v-if="props.canEdit" v-model="props.data.downloadReports.permission" default-first-option @change="handleApplicationsChange ">
          <el-option v-for="item in props.data.downloadReports.permissionOption" 
          :key="item.type" :label="item.name"
          :value="item.type" />
        </el-select>
        <span v-else>{{ switchParentText(props.data.downloadReports.permission) }}</span>
    </div>

      <div class="setting-item indented"  v-if="props.data.downloadCreatorPerformanceByDay">
        <span>Download creator performance by day</span>
        <div v-if="props.data.downloadReports.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.downloadCreatorPerformanceByDay.permission === 100"
            @click.native="switchItem(props.data, 'downloadCreatorPerformanceByDay.permission')" />
          <span v-else>{{ switchText(props.data.downloadCreatorPerformanceByDay.permission) }}</span>
        </div>
      </div>

      <div class="setting-item indented"  v-if="props.data.downloadPerformanceOverview">
        <span>Download performance overview</span>
        <div v-if="props.data.downloadReports.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.downloadPerformanceOverview.permission === 100"
            @click.native="switchItem(props.data, 'downloadPerformanceOverview.permission')" />
          <span v-else>{{ switchText(props.data.downloadPerformanceOverview.permission) }}</span>
        </div>
      </div>

      <div class="setting-item indented"  v-if="props.data.downloadProductPerformance">
        <span>Download product performance</span>
        <div v-if="props.data.downloadReports.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.downloadProductPerformance.permission === 100"
          @click.native="switchItem(props.data, 'downloadProductPerformance.permission')" />
          <span v-else>{{ switchText(props.data.downloadProductPerformance.permission) }}</span>
        </div>
    </div>

      <div class="setting-item indented"  v-if="props.data.downloadCollectionsPerformance">
        <span>Download collections performance</span>
        <div v-if="props.data.downloadReports.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.downloadCollectionsPerformance.permission === 100"
          @click.native="switchItem(props.data, 'downloadCollectionsPerformance.permission')" />
          <span v-else>{{ switchText(props.data.downloadCollectionsPerformance.permission) }}</span>
        </div>
    </div>

      <div class="setting-item indented"  v-if="props.data.downloadPostPerformance">
        <span>Download post performance</span>
        <div v-if="props.data.downloadReports.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.downloadPostPerformance.permission === 100"
            @click.native="switchItem(props.data, 'downloadPostPerformance.permission')" />
          <span v-else>{{ switchText(props.data.downloadPostPerformance.permission) }}</span>
        </div>
      </div>

      <div class="setting-item indented"  v-if="props.data.downloadBrandContentPerformance">
        <span>Download branded content performance</span>
        <div v-if="props.data.downloadReports.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.downloadBrandContentPerformance.permission === 100"
            @click.native="switchItem(props.data, 'downloadBrandContentPerformance.permission')" />
          <span v-else>{{ switchText(props.data.downloadBrandContentPerformance.permission) }}</span>
        </div>
      </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import Switch from '@/components/ui/Switch.vue';
import { ElSelect, ElOption } from 'element-plus';
import { useTeamFunction } from './teamFunction';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  isOwner: {
    type: Boolean,
    default: false
  },
  canEdit: {
    type: Boolean,
    default: false
  }
});

const { switchItem,switchText,switchParentText } = useTeamFunction();

//+++++++++++++++++++++++++++++
const handleApplicationsChange = (event) => {
  props.data.downloadCreatorPerformanceByDay.permission = event;
  props.data.downloadPerformanceOverview.permission = event;
  props.data.downloadProductPerformance.permission = event;
  props.data.downloadCollectionsPerformance.permission = event;
  props.data.downloadPostPerformance.permission = event;
  props.data.downloadBrandContentPerformance.permission = event;
};

</script>
